<template>
  <div
    class=" "
    id="app"
    :class="$route.query.permit === 'parent' ? 'change-pw-bg' : 'loginbg'"
  >
    <div id="app" class="col-sm-12 row mx-0 px-0">
      <div
        class="col-sm-12 d-flex justify-content-center align-items-center"
        v-if="loginShow === 'login'"
      >
        <div
          class="card login-bg-s"
          :class="colorStyle === 'dark' ? 'login-bg-s' : 'login-bg-s-white'"
        >
          <div class="card-body" id="card-body">
            <a class="brand text-center d-block m-b-20 m-t-20">
              <img class="msu_logo" :src="logo" alt="Logo" />
            </a>
            <h1
              class="text-left font-weight-bold"
              :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
            >
              Teacher account
            </h1>
            <ValidationObserver ref="loginForm">
              <div id="login-Page">
                <h5
                  class="sign-in-heading"
                  :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
                >
                  {{ $t("log-in-to-your-account") }}
                </h5>
                <ValidationProvider
                  rules="required"
                  v-slot="{ failed, errors }"
                  name="Account"
                >
                  <div class="mb-3">
                    <!-- <label for="inputEmail" class="sr-only">{{
                      $t("email-address")
                    }}</label> -->
                    <input
                      type="email"
                      id="inputEmail"
                      class="form-control form-control-lg text-dark"
                      :placeholder="$t('enter-your-email-address')"
                      required=""
                      v-model="loginForm.email"
                      :class="{ 'is-invalid': failed }"
                      autocomplete="email"
                    />
                    <!-- :autocomplete="remember === true ? '' : 'new-password'" -->
                    <span v-if="failed" class="text-danger">
                      {{ $t("e-mail-is-not-valid-0") }}</span
                    >
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  v-slot="{ failed, errors }"
                  name="Password"
                  ref="mypassword"
                >
                  <div class="mt-3">
                    <label for="inputPassword" class="sr-only">{{
                      $t("password")
                    }}</label>
                    <input
                      type="password"
                      id="inputPassword"
                      class="form-control form-control-lg text-dark"
                      :placeholder="$t('enter-your-password')"
                      required=""
                      v-model="loginForm.password"
                      :class="{ 'is-invalid': failed }"
                      autocomplete="Password"
                      :autocomplete="remember === true ? '' : 'new-password'"
                      @keyup.enter="login()"
                    />
                    <!-- :autocomplete="remember === true ? '' : 'new-password'" -->
                    <span v-if="failed" class="text-danger">{{
                      $t("password-is-not-valid")
                    }}</span>
                  </div>
                </ValidationProvider>
                <div class="row d-flex justify-content-between px-3 mt-3">
                  <div class="">
                    <input
                      type="checkbox"
                      aria-label="Checkbox for following text input"
                      v-model="checkRemember"
                    />
                    <span
                      class="ml-1 pointer font-weight-bold"
                      :class="
                        colorStyle === 'dark' ? 'text-white' : 'text-dark'
                      "
                      @click="checkRemember = !checkRemember"
                      >{{ $t("remember-me") }}</span
                    >
                  </div>
                  <span
                    class="float-right pointer font-weight-bold"
                    :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
                    @click="loginShow = 'forgetPassword'"
                    >{{ $t("forgot-password") }}?</span
                  >
                </div>
                <button
                  class="btn btn-primary btn-rounded btn-floating btn-md btn-block m-t-20 m-b-20 font-weight-bold"
                  @click="login()"
                >
                  {{ $t("log-in") }}
                </button>
              </div>
            </ValidationObserver>
            <div class="col-sm-12">
              <div
                v-if="specialInfo !== null"
                class="justify-content-center special-text col-sm-12"
                :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
                v-html="specialInfo"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- login reset pwd -->

      <div
        class="col-sm-12 d-flex justify-content-center align-items-center"
        v-if="loginShow === 'resetPasswordSuccess'"
      >
        <div class="card resetpw-content-bg p-5">
          <div class="card-body row justify-content-center align-items-center">
            <!-- <a class="brand text-center d-block m-b-20 m-t-20">
              <img class="msu_logo" :src="logo" alt="Logo" />
            </a> -->

            <p class="text-white text-center h3 font-weight-bold col-12">
              Reset Password
            </p>
            <p class="text-white text-center h6 col-12">
              {{ $t("e-mail") }}: {{ userEmail }}
            </p>
            <p class="text-center h3 my-3 col-12">
              <i class="zmdi zmdi-check-circle zmdi-hc-3x text-primary"></i>
            </p>
            <!-- <h5 class="sign-in-heading text-center text-success">
              {{ $t("password-set-successfully") }}
            </h5> -->
            <p
              class="text-center text-white col-12"
              v-if="
                getLMSD === 'tw' ||
                  getLMSD === 'pts' ||
                  (($getInternalVersion() === 'tw' ||
                    $getInternalVersion() === 'pts') &&
                    $route.query.permit === 'parent')
              "
            >
              {{
                $t(
                  "your-password-has-been-successfully-set-up-please-click-below-botton-and-first-login-with-your-chidrens-id-pw-when-you-back-to-mangosteems-universe-please-click-parent-function-to-login-with-you-email-and-password-for-reviewing-your-childrens-learning-statistics"
                )
              }}
            </p>
            <p class="text-center text-white col-12" v-else>
              {{
                $t(
                  "your-password-has-now-been-set-successfully-please-log-in-again"
                )
              }}
            </p>
            <div class="col-12 row mx-auto d-flex justify-content-center">
              <div class="col-9 d-flex justify-content-center">
                <button
                  v-if="
                    getLMSD === 'tw' ||
                      getLMSD === 'pts' ||
                      (($getInternalVersion() === 'tw' ||
                        $getInternalVersion() === 'pts') &&
                        $route.query.permit === 'parent')
                  "
                  class="font-weight-bold btn btn-primary btn-rounded btn-floating btn-md btn-block"
                  @click="loginRedirect()"
                >
                  {{ $t("back-to-login-with-students-id-pw") }}
                </button>
                <button
                  v-else
                  class="font-weight-bold btn btn-primary btn-rounded btn-floating btn-md btn-block"
                  @click="loginRedirect()"
                >
                  {{ $t("login") }}
                </button>
              </div>
            </div>

            <div class="d-flex justify-content-center">
              <!-- <div
                data-v-653f1d32=""
                class="text-white"
                style="
                  text-shadow: rgba(0, 0, 0, 0.7) 0px 2px 4px;
                  font-size: 20px;
                  font-weight: 500;
                "
              >
                {{ $t("teacher") }}
              </div> -->
              <div
                v-if="specialInfo !== null"
                class="text-white justify-content-center special-text col-sm-12"
                v-html="specialInfo"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-sm-12 d-flex justify-content-center align-items-center"
        v-if="loginShow === 'forgetPassword'"
      >
        <div class="card">
          <div
            class="card-body login-bg-s"
            :class="colorStyle === 'dark' ? 'login-bg-s' : 'login-bg-s-white'"
          >
            <a class="brand text-center d-block m-b-20 m-t-20">
              <img class="msu_logo" :src="logo" alt="Logo" />
              <!-- <span class="display-4">School Name</span> -->
            </a>

            <div id="forget-password-page">
              <h5
                class="sign-in-heading text-dark"
                :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
              >
                {{ $t("forgotten-password") }}?
              </h5>
              <p
                class=""
                :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
              >
                {{
                  $t("will-send-you-an-email-with-link-to-reset-your-password")
                }}.
              </p>
              <div class="form-group">
                <label for="inputEmail" class="sr-only">{{
                  $t("email-address")
                }}</label>
                <input
                  type="email"
                  id="inputEmail"
                  class="form-control form-control-lg"
                  placeholder="Enter your Email address"
                  required=""
                  v-model="loginForm.email"
                />
              </div>

              <button
                class="font-weight-bold btn btn-primary btn-rounded btn-floating btn-md btn-block m-t-20 m-b-20"
                @click="forgotPassword()"
              >
                {{ $t("send") }}
              </button>
              <div class="d-flex justify-content-center">
                <!-- <div
                  data-v-653f1d32=""
                  class="text-white"
                  style="
                    text-shadow: rgba(0, 0, 0, 0.7) 0px 2px 4px;
                    font-size: 20px;
                    font-weight: 500;
                  "
                >
                  {{ $t("teacher") }}
                </div> -->
                <div
                  v-if="specialInfo !== null"
                  class="justify-content-center special-text col-sm-12"
                  :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
                  v-html="specialInfo"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-sm-12 d-flex justify-content-center align-items-center"
        v-if="loginShow === 'resetPassword'"
      >
        <div class="card resetpw-content-bg p-5">
          <div
            class="card-body my-auto flex-row justify-content-center align-items-center"
          >
            <ValidationObserver ref="resetForm">
              <p class="text-white text-left h3 font-weight-bold">
                Reset Password
              </p>
              <p class="text-white text-left h6">
                {{ $t("e-mail") }}: {{ userEmail }}
              </p>
              <!-- \ -->
              <div class="input-min-height">
                <p class="sign-in-heading text-white mt-4 mb-0">
                  {{ $t("password") }}
                </p>
                <ValidationProvider
                  rules="required"
                  v-slot="{ failed, errors }"
                  name="password"
                  vid="confirmation"
                  ref="cpassword"
                >
                  <div class="form-group mb-0">
                    <label for="inputPassword" class="sr-only">{{
                      $t("password")
                    }}</label>
                    <input
                      :type="getShowPw"
                      id="inputPassword"
                      class="form-control form-control-lg form-rounded"
                      :placeholder="
                        $t('password-must-be-at-least-6-characters')
                      "
                      required=""
                      v-model="loginForm.password"
                    />
                    <span
                      v-if="failed && loginForm.password !== ''"
                      class="text-danger"
                    >
                      {{ $t("password-is-not-valid") }}</span
                    >
                    <i
                      id="checkEye"
                      class="fas"
                      @click="showPw = !showPw"
                      :class="showPw === true ? 'fa-eye' : 'fa-eye-slash'"
                    ></i>
                  </div>
                </ValidationProvider>
              </div>
              <!-- \ end -->
              <!-- \2 -->
              <div class="input-min-height">
                <p class="sign-in-heading text-white mb-0">
                  {{ $t("confirm-password") }}
                </p>
                <ValidationProvider
                  rules="required|confirmed:confirmation"
                  v-slot="{ failed, errors }"
                  name="confirm password"
                  ref="confirmPw"
                >
                  <div class="form-group">
                    <label for="inputPassword" class="sr-only">{{
                      $t("password")
                    }}</label>
                    <input
                      :type="getShowConfirmPw"
                      id="inputPassword"
                      class="form-control form-control-lg form-rounded"
                      :placeholder="$t('enter-your-password-again')"
                      required=""
                      v-model="loginForm.confirmpw"
                      @keyup.enter="resetPassword()"
                    />
                    <span
                      v-show="failed && loginForm.confirmpw !== ''"
                      class="text-danger"
                    >
                      {{ $t("password-is-not-valid") }}</span
                    >
                    <i
                      id="checkEye2"
                      class="fas"
                      @click="showConfirmPw = !showConfirmPw"
                      :class="
                        showConfirmPw === true ? 'fa-eye' : 'fa-eye-slash'
                      "
                    ></i>
                  </div>
                </ValidationProvider>
              </div>
              <!-- \2end  -->
              <p style="color: #32c1db">Both passwords must match</p>
              <div class="row col-12 mx-0 pr-0">
                <div class="col-6"></div>
                <div class="col-6 d-flex justify-content-end pr-0">
                  <button
                    class="font-weight-bold btn btn-danger btn-rounded btn-floating btn-md btn-block"
                    @click="resetPassword()"
                  >
                    {{ $t("reset-password") }}
                  </button>
                </div>
              </div>
            </ValidationObserver>
            <div class="d-flex justify-content-center">
              <!-- <div
                data-v-653f1d32=""
                class="text-white"
                style="
                  text-shadow: rgba(0, 0, 0, 0.7) 0px 2px 4px;
                  font-size: 20px;
                  font-weight: 500;
                "
              >
                {{ $t("teacher") }}
              </div> -->
              <div
                v-if="specialInfo !== null"
                class="text-white justify-content-center special-text col-sm-12"
                v-html="specialInfo"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-sm-12 d-flex justify-content-center align-items-center"
        v-if="loginShow === 'sendEmail'"
      >
        <div class="card">
          <div
            class="card-body login-bg-s"
            :class="colorStyle === 'dark' ? 'login-bg-s' : 'login-bg-s-white'"
          >
            <a class="brand text-center d-block m-b-20 m-t-20">
              <img class="msu_logo" :src="logo" alt="Logo" />
              <!-- <span class="display-4">School Name</span> -->
            </a>
            <p class="display-4 text-center">
              <i class="zmdi zmdi-mail-send zmdi-hc-fw text-success"></i>
            </p>
            <h5 class="sign-in-heading text-center text-success">
              {{ $t("password-reset-email-sent") }}
            </h5>
            <p
              class="text-center"
              :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
            >
              {{
                $t(
                  "an-email-has-been-sent-to-your-email-please-follow-the-directions-in-the-email-to-reset-your-password"
                )
              }}.
            </p>
            <button
              class="font-weight-bold btn btn-primary btn-rounded btn-floating btn-md btn-block m-t-20 m-b-20"
              @click="loginShow = 'login'"
            >
              {{ $t("ok") }}
            </button>
            <div class="d-flex justify-content-center">
              <!-- <div
                data-v-653f1d32=""
                class="text-white"
                style="
                  text-shadow: rgba(0, 0, 0, 0.7) 0px 2px 4px;
                  font-size: 20px;
                  font-weight: 500;
                "
              >
                {{ $t("teacher") }}
              </div> -->
              <div
                v-if="specialInfo !== null"
                class="justify-content-center special-text col-sm-12"
                :class="colorStyle === 'dark' ? 'text-white' : 'text-dark'"
                v-html="specialInfo"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- login -->
    <!-- new footer -->
    <LoginFooter></LoginFooter>
    <!-- footer end -->
  </div>
</template>

<script>
// privacy policy
(function(w, d) {
  var loader = function() {
    var s = d.createElement("script"),
      tag = d.getElementsByTagName("script")[0];
    s.src = "https://cdn.iubenda.com/iubenda.js";
    tag.parentNode.insertBefore(s, tag);
  };
  console.log(w.addEventListener);
  if (w.addEventListener) {
    w.addEventListener("load", loader, false);
  } else if (w.attachEvent) {
    w.attachEvent("onload", loader);
  } else {
    w.onload = loader;
  }
})(window, document);
//
import dayjs from "dayjs";
import {
  ApiLogin,
  ApiForgotPassword,
  ApiConfirmPassword,
  ApiActivateUser,
} from "../http/apis/Login";
import LoginFooter from "../components/LoginFooter.vue";
import VueCookies from "vue-cookies";
export default {
  name: "Login",

  data() {
    return {
      showErrorMessage: false,
      loginShow: "login",
      remember: false,
      loginForm: {
        email: "",
        password: "",
        confirmpw: "",
      },
      userEmail: "",
      ErrorMessage: "Your email or password is incorrect. please try again.",
      specialInfo: null,
      showPw: false,
      showConfirmPw: false,
      colorStyle: "dark",
      checkRemember: false,
    };
  },
  components: {
    LoginFooter,
  },
  created() {
    console.log(process.env.VUE_APP_LMSD);
    localStorage.removeItem("vuex");
    localStorage.removeItem("token_web");
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--; )
        document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
    }
    // //resetpassword用網址
    ///resetpassword/id=0430d89bd1005af68a291b2f980c8dcda8b9f761
    this.$store.dispatch("auth/setAuth", {
      token: "",
      isLogin: false,
      userid: "",
    });
  },
  watch: {
    loginShow() {
      let vm = this;
      if (this.loginShow === "resetPassword") {
        // reset Page
        this.$nextTick(() => {
          vm.$refs.cpassword.applyResult({
            errors: [vm.$t("password-is-not-valid")], // array of string errors
            valid: false, // boolean state
            failedRules: {}, // should be empty since this is a manual error.
          });
        });
        this.$nextTick(() => {
          console.log(vm.$refs.confirmPw);
          vm.$refs.confirmPw.applyResult({
            errors: [vm.$t("confirm-password-is-not-valid")], // array of string errors
            valid: false, // boolean state
            failedRules: {}, // should be empty since this is a manual error.
          });
        });
      }
    },
  },
  mounted() {
    // console.log(VueCookies);
    let vm = this;
    // Login  page
    this.$nextTick(() => {
      vm.$refs.mypassword.applyResult({
        errors: [vm.$t("password-is-not-valid")], // array of string errors
        valid: false, // boolean state
        failedRules: {}, // should be empty since this is a manual error.
      });
    });

    if (this.$route.params.id !== undefined) {
      this.activateUser(this.$route.params.id);
      this.loginShow = "resetPassword";

      this.userEmail = this.$route.params.email;
    }
    if (
      process.env.VUE_APP_LMSD === "honeybearkids" ||
      this.$getInternalVersion() === "honeybearkids"
    ) {
      this.specialInfo = process.env.VUE_APP_SpecialInfo;
    }
    // 得到記住的帳號
    this.getCookie();
  },
  computed: {
    getLMSD() {
      return process.env.VUE_APP_LMSD;
    },
    getShowPw() {
      if (this.showPw) {
        return "text";
      } else {
        return "password";
      }
    },
    getShowConfirmPw() {
      if (this.showConfirmPw) {
        return "text";
      } else {
        return "password";
      }
    },
    token() {
      return this.$store.state.auth.token;
    },
    logo() {
      return this.$store.state.common.logo;
    },
  },
  methods: {
    getCookie() {
      console.log("cookie = ", document.cookie);
      if (
        (document.cookie.length > 0 && document.cookie.includes("email")) ||
        localStorage.getItem("email") !== undefined
      ) {
        let arr = document.cookie.split("; "); //分割成一个个独立的“key=value”的形式
        console.log(arr[0]);
        this.loginForm.email = localStorage.getItem("email");
        if (typeof arr === "object") {
          arr.forEach((item) => {
            if (item.includes("email")) {
              this.loginForm.email = item.split("=")[1];
            }
          });
        }
        this.checkRemember = true;
        // for (let i = 0; i < arr.length; i++) {
        //   let arr2 = arr[i].split("="); // 再次切割，arr2[0]为key值，arr2[1]为对应的value
        //   arr2;
        //   if (arr2[0] === "email") {
        //     this.loginForm.email = arr2[1];
        //   }
        // }
      }
    },
    setCookie(email, days) {
      let date = new Date(); // 获取时间
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * days); // 保存的天数
      // 字符串拼接cookie
      const vueCookie = VueCookies;
      vueCookie.set("email", email, days);
      window.document.cookie =
        "email" + "=" + email + ";path=/;expires=" + date.toGMTString();
      // cookie 會失效 改存local
      localStorage.setItem("email", email);
    },
    loginRedirect() {
      if (this.$route.query.permit !== "parent") {
        console.log("web account reset success");
        this.loginShow = "login";
      } else {
        console.log("parents reset success");
        if (this.$route.query.ver === "1") {
          let url = `https://${process.env.VUE_APP_LMSD}.mangosteems.com/mobile`;
          console.log("url = ", url);
          window.location.href = url;
        } else {
          let url = `https://${process.env.VUE_APP_LMSD}.mangosteems.com/v2/`;
          console.log("url = ", url);
          window.location.href = url;
        }
      }
    },
    async forgotPassword() {
      console.log(this.loginForm.email);
      let result = await ApiForgotPassword.get(
        this.loginForm.email,
        this.$i18n.locale
      ).then((response) => {
        console.log(response);
        if (response.record === "Done") {
          this.$bus.$emit(
            "messsage:push",
            "Password reset information has been sent to your email, please check your email!",
            "success"
          );
          return true;
        }
      });
      if (result) {
        this.loginShow = "sendEmail";
      }
    },
    sendEmailResetPWD() {
      this.loginShow = "sendEmail";
    },
    async login() {
      let vm = this;
      const todayTimestamp = Math.floor(Date.now() / 1000);
      ApiLogin.post(this.loginForm)
        .then((response) => {
          console.log(response);
          window.localStorage.setItem("token_web", response.record);
          //vuex
          this.$store.dispatch("auth/setAuth", {
            token: response.record,
            isLogin: response.status === "success" ? true : false,
            userid: response.userID,
            username: response.username,
            email: response.email,
            permit: response.permit,
            todayTimestamp: todayTimestamp,
            image: response.image,
          });
          this.$store.dispatch("courseInfo/clearAllAssignment");
          // response.status === "success"
          if (response.status === "success") {
            // 保存帳號
            if (response.permit === "insadmin") {
              let insadminurl = `${process.env.VUE_APP_DOMAIN}/insadmin/banner`;
              window.location.href = insadminurl;
            } else {
            }
            if (vm.checkRemember) {
              vm.setCookie(vm.loginForm.email, 30);
              this.$router.push({
                path: "/course",
              });
            } else {
              this.$router.push({
                path: "/course",
              });
            }

            //
          } else {
            this.$bus.$emit(
              "messsage:push",
              "Oh snap ! Your email or password is incorrect. please try again.",
              "danger"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    resetPassword() {
      let vm = this;
      console.log(this.loginForm);
      // 223456
      this.$refs.resetForm.validate().then((success) => {
        if (success) {
          let obj = { password: this.loginForm.password };
          ApiConfirmPassword.post(this.$route.params.id, obj)
            .then((response) => {
              console.log(response);
              this.loginShow = "resetPasswordSuccess";
              vm.loginForm = {
                email: "",
                password: "",
                confirmpw: "",
              };
            })
            .catch((err) => {});
        }
      });
    },
    activateUser(activeid) {
      ApiActivateUser.get(activeid)
        .then((response) => {
          console.log(response);
          this.loginForm.email = response.record.email;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped lang="scss">
input[type="email"] {
  font-size: 16px !important;
}
input[type="password"] {
  font-size: 16px !important;
}
// .bg-BETA {
//   background-color: #ff9100;
// }
.loginbg {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  min-height: 100%;
  background-image: url("../assets/img/avatars/login page_background-01.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.beta_div {
  background-color: #f56523;
  border-radius: 5px;
  color: white;
  font-size: 10px;
  font-weight: 500;
  padding: 0px 4px;
  vertical-align: top;
}

.login-bg-s {
  // background-image: url("../assets/img/avatars/bg-login-s.png");
  background-color: #3d1c4b;
  opacity: 0.8;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: 51% 34%;
  // background-size: 100% auto;
  background-size: cover;
  border-radius: 10px;
  // width: 450px;
  height: 580px;
  box-shadow: 12px 12px 7px rgba(0, 0, 0, 0.5);
}
.login-bg-s-white {
  background-color: #e6e6e6;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: 51% 34%;
  background-size: cover;
  border-radius: 10px;
  height: 580px;
  box-shadow: 12px 12px 7px rgba(0, 0, 0, 0.5);
}
@media (max-width: 1920px) {
  .login-bg-s {
    // background-image: url("../assets/img/avatars/bg-login-s.png");
    background-color: #3d1c4b;
    opacity: 0.8;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: 56% 45%;
    // background-size: 100% auto;
    background-size: cover;
    border-radius: 10px;
    // width: 450px;
  }
  .login-bg-s-white {
    background-color: #e6e6e6;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: 56% 45%;

    background-size: cover;
    border-radius: 10px;
  }
}
@media (max-width: 1367px) {
  .login-bg-s {
    // background-image: url("../assets/img/avatars/bg-login-s.png");
    background-color: #3d1c4b;
    opacity: 0.8;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: 51% 35%;
    // background-size: 100% auto;
    background-size: cover;
    border-radius: 10px;
    // width: 450px;
  }
  .login-bg-s-white {
    background-color: #e6e6e6;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: 51% 35%;

    background-size: cover;
    border-radius: 10px;
  }
}
@media (max-width: 1200px) {
  .login-bg-s {
    // background-image: url("../assets/img/avatars/bg-login-s.png");
    background-color: #3d1c4b;
    opacity: 0.8;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: 51% 34%;
    background-size: cover;
    // background-size: 100% auto;
    border-radius: 10px;
    // width: 450px;
  }
  .login-bg-s-white {
    background-color: #e6e6e6;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: 51% 34%;
    background-size: cover;

    border-radius: 10px;
  }
}

// .msu_logo {
//   // transform: scale(1.5);
//   width: 100%;
//   height: 100%;
// }
// @media (max-width: 1024px) {}
// @media (max-width: 860px) {}

.col-sm-12 d-flex justify-content-center align-items-center {
  margin: 12% auto 0;
}
.special-text {
  font-size: 12px;
}
.iubenda-embed {
  height: 18px;
}
.app {
  height: 100%;
}

.change-pw-bg {
  background-size: cover;
  min-height: 100%;
  background-image: url("../assets/img/background/big-demo-web.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
}
.resetpw-content-bg {
  background-color: #3d1c4b;
  max-width: 390px;
  min-width: 390px;
  min-height: 420px;
  opacity: 0.9;
}

#checkEye {
  position: absolute;
  top: 36%;
  right: 36px;
  transform: translateY(-50%);
}

#checkEye2 {
  position: absolute;
  top: 57%;
  right: 36px;
  transform: translateY(-50%);
}

.input-min-height {
  min-height: 87px;
}
.form-rounded {
  border-radius: 15px;
}
</style>
